import { render } from "./Plant.vue?vue&type=template&id=245d4ac2"
import script from "./Plant.vue?vue&type=script&lang=js"
export * from "./Plant.vue?vue&type=script&lang=js"
script.render = render

export default script